import $i18n from '@alife/panda-i18n';
import React from 'react';
import BatchInputBase from '@alife/cn-sc-batch-input';
const BatchInput = (prop) => {
    const { maxCount } = prop;
    const placeholder = maxCount
        ? $i18n.get({
            id: 'MaximumMaxCountBarSupport',
            dm: '最多支持{maxCount}条',
        }, { maxCount: maxCount })
        : $i18n.get({ id: 'gxms-pc_Enter.CNTM', dm: '请输入' });
    return React.createElement(BatchInputBase, { size: 'medium', ...prop, placeholder: placeholder });
};
BatchInput.displayName = 'BatchInput';
export { BatchInput };
